
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { debugLog } from '../utils/debugLogger';

let supabaseInstance: SupabaseClient | null = null;

/**
 * Initializes the Supabase client using runtime configuration.
 * Must be called once at app startup.
 */
export const initSupabase = (url: string, anonKey: string) => {
  if (supabaseInstance) return; // Already initialized

  if (!url || !anonKey) {
    console.error("Supabase Initialization Failed: Missing URL or Key");
    return;
  }

  debugLog("SUPABASE", "Initializing Client", { url });

  supabaseInstance = createClient(url, anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    }
  });
};

/**
 * Returns the initialized Supabase client.
 * Throws an error if accessed before initialization.
 */
export const getSupabase = (): SupabaseClient => {
  if (!supabaseInstance) {
    throw new Error("Supabase client not initialized. Ensure runtime config is loaded.");
  }
  return supabaseInstance;
};

// Deprecated: For backward compatibility during refactor, but essentially unsafe now.
// We export a proxy that throws if accessed too early, helping catch direct usage.
export const supabase = new Proxy({} as SupabaseClient, {
  get: (_target, prop) => {
    if (!supabaseInstance) {
      console.error(`Attempted to access supabase.${String(prop)} before initialization.`);
      throw new Error("Supabase client not initialized.");
    }
    return (supabaseInstance as any)[prop];
  }
});
